import axios from 'axios';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { axiosPath, path } from '../../../routing/helpers/router';
import * as globalActions from '../../../store/actions/globalAction';

export default function BreadcrumbHandler(props) {
  const {
    paths = [],
  } = props;
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const [initialPaths, setInitialPaths] = useState(paths);
  const [prependRoutes, setPrependRoutes] = useState([]);
  const [isLoadingPrependRoutes, setIsLoadingPrependRoutes] = useState(true);

  // > LOAD BREADCRUMB PREPEND //
  const loadBreadcrumbPrepend = async () => {
    try {
      const response = await axios.post(axiosPath('api_r_user_authUser_getBreadcrumbPrepend'), { moduleBridgeHex });
      return response.data;
    } catch (err) {}
  };

  useEffect(() => {
    if (moduleBridgeHex) {
      loadBreadcrumbPrepend().then((r) => {
        setIsLoadingPrependRoutes(false);
        setPrependRoutes(r);
      });
    } else setIsLoadingPrependRoutes(false);
  }, []);
  // < LOAD BREADCRUMB PREPEND //

  const createRoutes = (paths) => paths.map((p) => {
    let route = {
      name: p.name,
    };

    if (p.route) {
      route = p.isOld
        ? { ...route, route: p.route, isOld: true }
        : { ...route, route: path(p.route) };
    }

    return route;
  });

  useEffect(() => {
    if (!_.isEqual(paths, initialPaths)) setInitialPaths(paths);
  }, [paths]);

  useEffect(() => {
    if (!isLoadingPrependRoutes) {
      dispatch(globalActions.setBreadcrumb([
        ...createRoutes(prependRoutes),
        ...createRoutes(paths),
      ]));
    }
  }, [initialPaths, prependRoutes, isLoadingPrependRoutes]);

  return null;
}
